<template>
  <div class="icons-grid-section">
    <div class="container">
      <h2>
        <slot name="title"></slot>
      </h2>
      <div class="row justify-content-between">
        <div
          v-for="(item, index) in gridElements"
          :key="index"
          class="col-sm col-md-4 single-item"
        >
          <div class="w-75 d-flex flex-column mx-auto align-items-center h-100">
            <img
              :src="`/static/assets/imgs/industries/${item.graphic}`"
              alt="Icon"
              class="mb-4"
            />
            <span class="text-center">{{ item.title }}</span>
            <p class="text-center mb-0">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gridElements: Array,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 40px;
  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 20px;
  }
}
.icons-grid-section {
  background-color: #eff9fe;
}
h2 {
  font-size: 30px !important;
  font-weight: 700;
  margin: 0;
  margin-bottom: 60px;
  text-align: center;
  font-family: "Biotif", "Helvetica", sans-serif;

  @media (min-width: 768px) {
    font-size: 36px !important;
  }
}

.single-item {
  margin-bottom: 40px;

  @media (min-width: 768px) {
    margin-bottom: 60px;
  }

  img {
    max-width: 50px;
    height: 50px;
  }

  span {
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 22px;
  }

  p {
    margin-top: auto;
    font-size: 18px;
    color: #666;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// IconsGrid.vue?a7df9e6c